<template>
	<div class="benefit-row" >
		<ximg
			:class="['benefit-thumbnail', { scaled: scaleIcon }]"
			:src="iconSrc"
			lazy
			:ariaLabel="'benefit icon ' + benefit.name"
			role="img"
		/>
		<div class="benefit-info">
			<div class="benefit-title">
				{{ benefit.name }}
			</div>
			<div class="benefit-description">
				<p v-html="benefit.description"></p>
				<p v-if="validTo">Aktiv t.o.m. {{ validToDate }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import { convertToCdnUrl } from 'utils';
import PHPDate from 'PHPDate';

export default {
	props: {
		benefit: {
			type: Object,
		},
		validTo: {
			type: Number,
			default: null,
		},
		scaleIcon: {
			type: Boolean,
			deafult: false,
		},
	},
	computed: {
		iconSrc () {
			return convertToCdnUrl(this.benefit.icon);
		},
		validToDate () {
			const validTo = PHPDate('Y-m-d', this.validTo);
			return validTo;
		},
	},
};
</script>
